module.exports = __webpack_public_path__ + "img/helmet_home.fe90598b.png";